import { applyMiddleware, createStore } from 'redux';
import { thunk } from 'redux-thunk';

import { composeWithDevTools } from '@redux-devtools/extension';
import rootReducer from 'reducers';

export default function getStore(initState) {
    const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });
    const middeleware = !__isProd__ ? composeEnhancers(applyMiddleware(thunk)) : applyMiddleware(thunk);
    return createStore(rootReducer, initState, middeleware);
}
